module.exports = __webpack_public_path__ + "img/dust-extraction.2e95d191.jpg";